import { Injectable } from '@angular/core';
import { GoogleGenerativeAI } from '@google/generative-ai';
import { BehaviorSubject, Observable } from 'rxjs';
import { CrmsettingsService } from './crmsettings.service';
import { EcryptServiceService } from '../core/auth/EcryptionService/ecrypt-service.service';

@Injectable({
  providedIn: 'root'
})
export class GeminiService {

  private generativeAI: GoogleGenerativeAI

  private messageHistory:BehaviorSubject<any> = new BehaviorSubject(null);
  crmSettingsData: any;
  constructor(public crm:CrmsettingsService,private ecryptService: EcryptServiceService) {
    let aiApiKey : any;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);
        console.log("CRM Settings Data:", this.crmSettingsData);
  
        aiApiKey = this.crmSettingsData.aiApiKey;
      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }



    this.generativeAI = new GoogleGenerativeAI(aiApiKey);


    //this.generativeAI = new GoogleGenerativeAI('AIzaSyCdCzbSLwQ_gdHwu-CQl0wtdO0rdCtIIMY');
   }

   async generateText(promt:string) {

    const model = this.generativeAI.getGenerativeModel({model: 'gemini-pro'});

    this.messageHistory.next({
      from:'user',
      message:promt
    });
    const result = await model.generateContent(promt);
    const response = await result.response;
    const text = response.text();
    console.log(text);
    this.messageHistory.next({
      from: 'bot',
      message: text
    })
   }

   public getMessageHistory():Observable<any>{
    return this.messageHistory.asObservable();
   }
}
